import type { Uuid } from "@/domains/global/identifiers";
import type { AppStore } from "@/store/AppStore";

export const getCurrentAssistantId = async ({
  store,
}: {
  store: AppStore;
}): Promise<Uuid | undefined> => {
  const settingsRows = await store.assistantSpaceAccountSettings.localTable.toArray();
  const personalSpaceAccountId = store.spaceAccounts.myPersonalSpaceAccountId;

  return (
    settingsRows.find(
      settingsRow => settingsRow.model_data.space_account_id === personalSpaceAccountId
    ) ?? settingsRows[0]
  )?.model_data.assistant_id;
};
